import Vue from 'vue';
import Vuex from 'vuex';
import VuexORM from '@vuex-orm/core';
import database from './database';
import App from './modules/App';
import AppPersistent from './modules/AppPersistent';
import VuexORMisDirtyPlugin from '@vuex-orm/plugin-change-flags';
import createPersistedState from 'vuex-persistedstate';
// import LogRocket from 'logrocket';
// import createLogRocketPlugin from 'logrocket-vuex';

/* Register plugins */
Vue.use(Vuex)
VuexORM.use(VuexORMisDirtyPlugin)

/**
 * Create a LogRocket Plugin
 */
// const logrocketPlugin = createLogRocketPlugin(LogRocket, function(mutation) {
//   if (mutation.type === 'entities/insertRecords' && mutation.payload && mutation.payload.records) {
//     return {
//       type: mutation.payload.entity && mutation.payload.entity.toUpperCase() + '_INSERT',
//       payload: mutation.payload
//     }
//   }
// })

/* Create Vuex Store and register database through Vuex ORM */
const store = new Vuex.Store({
  modules: {
    App,
    AppPersistent
  },

  plugins: [
    VuexORM.install(database),
    // logrocketPlugin,
    createPersistedState({
      key: 'reka',
      modules: ['App', 'AppPersistent', 'entities']
    })
  ]
})

export default store
